export default __webpack_public_path__ + "static/media/eswara.692ad183.jpeg";